module.exports = __webpack_public_path__ + "img/20b-consultas-cadastros-economico.2eecc9e3.png";